/**
 * Shipping Estimate Widget
 * Auto-detects country (MarketConfig), shows PIN/emirate/zip input, displays estimated delivery dates.
 */
(function() {
  'use strict';

  var MUMBAI_PREFIX = '400';
  var METRO_PREFIXES = ['400', '110', '121', '380', '560', '700', '600', '500', '411'];
  var UAE_EMIRATES = [
    { value: 'abu-dhabi', label: 'Abu Dhabi' },
    { value: 'dubai', label: 'Dubai' },
    { value: 'sharjah', label: 'Sharjah' },
    { value: 'ajman', label: 'Ajman' },
    { value: 'umm-al-quwain', label: 'Umm Al Quwain' },
    { value: 'ras-al-khaimah', label: 'Ras Al Khaimah' },
    { value: 'fujairah', label: 'Fujairah' }
  ];

  var DELIVERY_COUNTRIES = [
    { code: 'IN', key: 'default', label: 'India' },
    { code: 'AE', key: 'en-ae', label: 'United Arab Emirates' },
    { code: 'AE', key: 'ar-ae', label: 'United Arab Emirates' },
    { code: 'SA', key: 'en-sa', label: 'Saudi Arabia' },
    { code: 'SA', key: 'ar-sa', label: 'Saudi Arabia' },
    { code: 'GB', key: 'en-gb', label: 'United Kingdom' },
    { code: 'SG', key: 'en-sg', label: 'Singapore' },
    { code: 'US', key: 'en-us', label: 'United States' },
    { code: 'CA', key: 'en-ca', label: 'Canada' },
    { code: 'AU', key: 'en-au', label: 'Australia' }
  ];

  function getConfig(widget) {
    var script = widget.querySelector('[data-shipping-estimate-settings]');
    if (!script || !script.textContent) return {};
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return {};
    }
  }

  function getMarket() {
    if (typeof window.MarketConfig !== 'undefined' && window.MarketConfig.getCurrentMarket) {
      var m = window.MarketConfig.getCurrentMarket();
      return { key: m.key, countryCode: m.config ? m.config.countryCode : 'IN' };
    }
    var path = window.location.pathname || '';
    if (path.indexOf('/ar-ae') === 0) return { key: 'ar-ae', countryCode: 'AE' };
    if (path.indexOf('/en-ae') === 0) return { key: 'en-ae', countryCode: 'AE' };
    if (path.indexOf('/ar-sa') === 0) return { key: 'ar-sa', countryCode: 'SA' };
    if (path.indexOf('/en-sa') === 0) return { key: 'en-sa', countryCode: 'SA' };
    if (path.indexOf('/en-gb') === 0) return { key: 'en-gb', countryCode: 'GB' };
    if (path.indexOf('/en-sg') === 0) return { key: 'en-sg', countryCode: 'SG' };
    if (path.indexOf('/en-us') === 0) return { key: 'en-us', countryCode: 'US' };
    if (path.indexOf('/en-ca') === 0) return { key: 'en-ca', countryCode: 'CA' };
    if (path.indexOf('/en-au') === 0) return { key: 'en-au', countryCode: 'AU' };
    return { key: 'default', countryCode: 'IN' };
  }

  function addBusinessDays(date, days, tz) {
    var d = new Date(date);
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      var dow = d.getUTCDay();
      if (dow !== 0 && dow !== 6) added++;
    }
    return d;
  }

  function addCalendarDays(date, days) {
    var d = new Date(date);
    d.setDate(d.getDate() + days);
    return d;
  }

  function addUTCDays(date, days) {
    var d = new Date(date);
    d.setUTCDate(d.getUTCDate() + days);
    return d;
  }

  function formatDate(date) {
    return date.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' });
  }

  function formatDateShort(date) {
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  }

  function formatDateShortIST(date) {
    try {
      return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', timeZone: IST });
    } catch (e) {
      return formatDateShort(date);
    }
  }

  function nextBusinessDay(date) {
    var d = new Date(date);
    d.setDate(d.getDate() + 1);
    var dow = d.getUTCDay();
    if (dow === 0) d.setDate(d.getDate() + 1);  // Sunday -> Monday
    if (dow === 6) d.setDate(d.getDate() + 2); // Saturday -> Monday
    return d;
  }

  function showHint(widget, message) {
    var hint = widget.querySelector('[data-shipping-hint]');
    var columns = widget.querySelector('[data-shipping-columns]');
    var timerEl = widget.querySelector('[data-shipping-timer]');
    if (hint) { hint.textContent = message; hint.style.display = ''; }
    if (columns) columns.style.display = 'none';
    if (timerEl) timerEl.style.display = 'none';
  }

  function showColumns(widget, dispatchText, urgentText, standardText, showUrgent) {
    var hint = widget.querySelector('[data-shipping-hint]');
    var columns = widget.querySelector('[data-shipping-columns]');
    var timerEl = widget.querySelector('[data-shipping-timer]');
    var dispatchEl = widget.querySelector('[data-shipping-dispatch]');
    var urgentEl = widget.querySelector('[data-shipping-urgent]');
    var standardEl = widget.querySelector('[data-shipping-standard]');
    if (hint) hint.style.display = 'none';
    if (columns) columns.style.display = '';
    if (timerEl) { timerEl.style.display = ''; updateTimer(widget); }
    if (dispatchEl) dispatchEl.textContent = dispatchText || '';
    if (urgentEl) { urgentEl.textContent = urgentText || ''; urgentEl.closest('.shipping-estimate__col').style.display = showUrgent !== false ? '' : 'none'; }
    if (standardEl) standardEl.textContent = standardText || '';
  }

  var IST = 'Asia/Kolkata';
  var CUTOFF_HOUR_IST = 14;   // 2 PM IST - order before this for same-day dispatch
  var SUNDAY = 0;             // Sunday is not a working day

  function getNowIST() {
    try {
      var now = new Date();
      var f = new Intl.DateTimeFormat('en-CA', {
        timeZone: IST,
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', hour12: false,
        weekday: 'short'
      });
      var parts = f.formatToParts(now);
      var o = {};
      parts.forEach(function(p) {
        if (p.type !== 'literal') o[p.type] = p.value;
      });
      var weekdayMap = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
      return {
        year: parseInt(o.year, 10),
        month: parseInt(o.month, 10) - 1,
        day: parseInt(o.day, 10),
        hours: parseInt(o.hour, 10),
        minutes: parseInt(o.minute, 10),
        dayOfWeek: weekdayMap[o.weekday] !== undefined ? weekdayMap[o.weekday] : 0
      };
    } catch (e) {
      var d = new Date();
      return {
        year: d.getFullYear(), month: d.getMonth(), day: d.getDate(),
        hours: d.getHours(), minutes: d.getMinutes(),
        dayOfWeek: d.getDay()
      };
    }
  }

  function isBusinessDayIST(dayOfWeek) {
    return dayOfWeek >= 1 && dayOfWeek <= 6;
  }

  function getDispatchDateIST() {
    var n = getNowIST();
    if (isBusinessDayIST(n.dayOfWeek) && (n.hours < CUTOFF_HOUR_IST || (n.hours === CUTOFF_HOUR_IST && n.minutes === 0))) {
      return new Date(Date.UTC(n.year, n.month, n.day));
    }
    var d = new Date(Date.UTC(n.year, n.month, n.day));
    d.setUTCDate(d.getUTCDate() + 1);
    while (getWeekdayIST(d) === SUNDAY) {
      d.setUTCDate(d.getUTCDate() + 1);
    }
    return d;
  }

  function getWeekdayIST(date) {
    try {
      var f = new Intl.DateTimeFormat('en', { timeZone: IST, weekday: 'short' });
      var w = f.format(date);
      var map = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
      return map[w] !== undefined ? map[w] : 0;
    } catch (e) {
      return date.getUTCDay();
    }
  }

  function getNext2PMIST() {
    var n = getNowIST();
    var year = n.year, month = n.month, day = n.day;
    if (isBusinessDayIST(n.dayOfWeek) && n.hours < CUTOFF_HOUR_IST) {
      return new Date(Date.UTC(year, month, day, 8, 30, 0, 0));
    }
    var d = new Date(Date.UTC(year, month, day));
    d.setUTCDate(d.getUTCDate() + 1);
    while (getWeekdayIST(d) === SUNDAY) d.setUTCDate(d.getUTCDate() + 1);
    return new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate(), 8, 30, 0, 0));
  }

  function nowInTimezone(tz) {
    try {
      return new Date(new Date().toLocaleString('en-US', { timeZone: tz || 'Asia/Kolkata' }));
    } catch (e) {
      return new Date();
    }
  }

  function indiaRegion(prefix) {
    if (prefix === MUMBAI_PREFIX) return { type: 'mumbai', standardDays: 2, urgentDays: 1 };
    if (METRO_PREFIXES.indexOf(prefix) !== -1) return { type: 'metro', standardDays: 3, urgentDays: 1 };
    return { type: 'rest', standardDaysMin: 3, standardDaysMax: 5, urgentDays: 2 };
  }

  function renderIndiaEstimates(pin, config, widget) {
    var prefix = pin.slice(0, 3);
    var region = indiaRegion(prefix);
    var showUrgent = config.showUrgent !== false;

    var dispatchDate = getDispatchDateIST();
    var standardDate, urgentDate;
    if (region.type === 'mumbai') {
      standardDate = addUTCDays(dispatchDate, region.standardDays);
      urgentDate = addUTCDays(dispatchDate, region.urgentDays);
    } else if (region.type === 'metro') {
      standardDate = addUTCDays(dispatchDate, region.standardDays);
      urgentDate = addUTCDays(dispatchDate, region.urgentDays);
    } else {
      standardDate = addUTCDays(dispatchDate, region.standardDaysMax);
      urgentDate = addUTCDays(dispatchDate, region.urgentDays);
    }

    var dispatchStr = formatDateShortIST(dispatchDate);
    var urgentStr = formatDateShortIST(urgentDate);
    var standardStr = formatDateShortIST(standardDate);
    showColumns(widget, dispatchStr, urgentStr, standardStr, showUrgent);
    widget.querySelector('[data-shipping-results]').classList.remove('hidden');
  }

  function addBusinessDaysFromUTC(dateUTC, days) {
    var d = new Date(dateUTC);
    var added = 0;
    while (added < days) {
      d.setUTCDate(d.getUTCDate() + 1);
      if (d.getUTCDay() !== SUNDAY) added++;
    }
    return d;
  }

  function renderUAEEstimates(config, widget) {
    var dispatchDate = getDispatchDateIST();
    var urgentDate = addBusinessDaysFromUTC(dispatchDate, 2);
    var standardDate = addBusinessDaysFromUTC(dispatchDate, 4);
    var showUrgent = config.showUrgent !== false;

    var dispatchStr = formatDateShortIST(dispatchDate);
    var urgentStr = formatDateShortIST(urgentDate);
    var standardStr = formatDateShortIST(standardDate);
    showColumns(widget, dispatchStr, urgentStr, standardStr, showUrgent);
    widget.querySelector('[data-shipping-results]').classList.remove('hidden');
  }

  function renderUKEstimates(config, widget) {
    var dispatchDate = getDispatchDateIST();
    var urgentDate = addBusinessDaysFromUTC(dispatchDate, 2);
    var standardDate = addBusinessDaysFromUTC(dispatchDate, 3);
    var showUrgent = config.showUrgent !== false;

    var dispatchStr = formatDateShortIST(dispatchDate);
    var urgentStr = formatDateShortIST(urgentDate);
    var standardStr = formatDateShortIST(standardDate);
    showColumns(widget, dispatchStr, urgentStr, standardStr, showUrgent);
    widget.querySelector('[data-shipping-results]').classList.remove('hidden');
  }

  function renderInternationalEstimates(config, widget) {
    var standardDays = 6;
    var urgentDays = 2;
    var dispatchDate = getDispatchDateIST();
    var standardDate = addBusinessDaysFromUTC(dispatchDate, standardDays);
    var urgentDate = addBusinessDaysFromUTC(dispatchDate, urgentDays);
    var showUrgent = config.showUrgent !== false;

    var dispatchStr = formatDateShortIST(dispatchDate);
    var urgentStr = formatDateShortIST(urgentDate);
    var standardStr = formatDateShortIST(standardDate);
    showColumns(widget, dispatchStr, urgentStr, standardStr, showUrgent);
    widget.querySelector('[data-shipping-results]').classList.remove('hidden');
  }

  function validateIndiaPin(val) {
    return /^\d{6}$/.test(String(val).trim());
  }

  function validateSaudiZip(val) {
    return /^\d{5}$/.test(String(val).trim());
  }

  function validateUKPostcode(val) {
    return /^[A-Za-z]{1,2}\d[A-Za-z\d]?\s*\d[A-Za-z]{2}$/i.test(String(val).trim().replace(/\s+/g, ' '));
  }

  function validateSingaporeZip(val) {
    return /^\d{6}$/.test(String(val).trim());
  }

  function validateUSZip(val) {
    return /^\d{5}(-\d{4})?$/.test(String(val).trim());
  }

  function validateCanadaPostcode(val) {
    return /^[A-Za-z]\d[A-Za-z][\s-]?\d[A-Za-z]\d$/i.test(String(val).trim());
  }

  function validateAustraliaPostcode(val) {
    return /^\d{4}$/.test(String(val).trim());
  }

  function validateZip(countryCode, val) {
    switch (countryCode) {
      case 'SA': return validateSaudiZip(val);
      case 'GB': return validateUKPostcode(val);
      case 'SG': return validateSingaporeZip(val);
      case 'US': return validateUSZip(val);
      case 'CA': return validateCanadaPostcode(val);
      case 'AU': return validateAustraliaPostcode(val);
      default: return false;
    }
  }

  function buildInputIndia(config, widget) {
    var wrap = widget.querySelector('[data-shipping-input-wrap]');
    var pinPlaceholder = config.pinPlaceholder || 'Enter 6-digit PIN code';
    var enterPinMessage = config.enterPinMessage || 'Enter your PIN code to see delivery estimates.';
    var invalidPinMessage = config.invalidPinMessage || 'Please enter a valid 6-digit PIN code.';
    var resultsEl = widget.querySelector('[data-shipping-results]');
    var errorEl = widget.querySelector('[data-shipping-error]');

    wrap.innerHTML = '<input type="text" inputmode="numeric" pattern="[0-9]*" maxlength="6" placeholder="' + (pinPlaceholder.replace(/"/g, '&quot;')) + '" class="shipping-estimate__input" data-shipping-pin data-shipping-input autocomplete="postal-code">';
    showHint(widget, enterPinMessage);
    resultsEl.classList.remove('hidden');
    errorEl.classList.add('hidden');
    errorEl.textContent = '';

    var input = wrap.querySelector('[data-shipping-pin]');
    function update() {
      var val = input.value.trim();
      errorEl.classList.add('hidden');
      errorEl.textContent = '';
      if (val.length === 0) {
        showHint(widget, enterPinMessage);
        return;
      }
      if (!validateIndiaPin(val)) {
        if (val.length === 6) {
          errorEl.textContent = invalidPinMessage;
          errorEl.classList.remove('hidden');
        }
        showHint(widget, enterPinMessage);
        return;
      }
      renderIndiaEstimates(val, config, widget);
    }
    input.addEventListener('input', update);
    input.addEventListener('blur', update);
  }

  function buildInputUAE(config, widget) {
    var wrap = widget.querySelector('[data-shipping-input-wrap]');
    var emiratePlaceholder = config.emiratePlaceholder || 'Select emirate';
    var selectEmirateMessage = config.selectEmirateMessage || 'Select emirate to see delivery estimates.';
    var resultsEl = widget.querySelector('[data-shipping-results]');
    var errorEl = widget.querySelector('[data-shipping-error]');

    var select = document.createElement('select');
    select.className = 'shipping-estimate__select';
    select.setAttribute('data-shipping-emirate', '');
    select.setAttribute('data-shipping-input', '');
    select.setAttribute('autocomplete', 'country-name');
    var opt0 = document.createElement('option');
    opt0.value = '';
    opt0.textContent = emiratePlaceholder;
    select.appendChild(opt0);
    UAE_EMIRATES.forEach(function(em) {
      var opt = document.createElement('option');
      opt.value = em.value;
      opt.textContent = em.label;
      select.appendChild(opt);
    });
    wrap.innerHTML = '';
    wrap.appendChild(select);
    showHint(widget, selectEmirateMessage);
    resultsEl.classList.remove('hidden');
    errorEl.classList.add('hidden');

    select.addEventListener('change', function() {
      if (select.value) {
        renderUAEEstimates(config, widget);
      } else {
        showHint(widget, selectEmirateMessage);
      }
    });
  }

  function buildInputZip(countryCode, config, widget) {
    var wrap = widget.querySelector('[data-shipping-input-wrap]');
    var zipPlaceholder = config.zipPlaceholder || config.zipPlaceholderText || 'Enter postcode';
    var invalidZipMessage = config.invalidZipMessage || config.invalidZipText || 'Please enter a valid postcode.';
    var enterZipHint = config.enterZipHint || config.enterZipMessage || config.enterZipText || 'Enter your postcode to see delivery estimates.';
    var resultsEl = widget.querySelector('[data-shipping-results]');
    var errorEl = widget.querySelector('[data-shipping-error]');

    wrap.innerHTML = '<input type="text" placeholder="' + (zipPlaceholder.replace(/"/g, '&quot;')) + '" class="shipping-estimate__input" data-shipping-zip data-shipping-input autocomplete="postal-code">';
    showHint(widget, enterZipHint);
    resultsEl.classList.remove('hidden');
    errorEl.classList.add('hidden');
    errorEl.textContent = '';

    var input = wrap.querySelector('[data-shipping-zip]');
    function update() {
      var val = input.value.trim();
      errorEl.classList.add('hidden');
      errorEl.textContent = '';
      if (val.length === 0) {
        showHint(widget, enterZipHint);
        return;
      }
      if (!validateZip(countryCode, val)) {
        errorEl.textContent = invalidZipMessage;
        errorEl.classList.remove('hidden');
        showHint(widget, enterZipHint);
        return;
      }
      if (countryCode === 'GB') {
        renderUKEstimates(config, widget);
      } else {
        renderInternationalEstimates(config, widget);
      }
    }
    input.addEventListener('input', update);
    input.addEventListener('blur', update);
  }

  function buildInputForCountry(countryCode, config, widget) {
    var inputWrap = widget.querySelector('[data-shipping-input-wrap]');
    var resultsEl = widget.querySelector('[data-shipping-results]');
    var errorEl = widget.querySelector('[data-shipping-error]');
    if (!inputWrap || !resultsEl || !errorEl) return;

    errorEl.classList.add('hidden');
    errorEl.textContent = '';

    if (countryCode === 'IN') {
      buildInputIndia(config, widget);
      return;
    }
    if (countryCode === 'AE') {
      buildInputUAE(config, widget);
      return;
    }
    if (['SA', 'GB', 'SG', 'US', 'CA', 'AU'].indexOf(countryCode) !== -1) {
      buildInputZip(countryCode, config, widget);
      return;
    }
    showHint(widget, 'Delivery estimates for your region: please contact us.');
    resultsEl.classList.remove('hidden');
  }

  function getCountryLabel(countryCode, config) {
    if (config && config.countryLabels && config.countryLabels[countryCode]) {
      return config.countryLabels[countryCode];
    }
    for (var i = 0; i < DELIVERY_COUNTRIES.length; i++) {
      if (DELIVERY_COUNTRIES[i].code === countryCode) return DELIVERY_COUNTRIES[i].label;
    }
    return 'India';
  }

  function buildCountryDropdown(config, widget) {
    var countryWrap = widget.querySelector('[data-shipping-country-wrap]');
    var inputWrap = widget.querySelector('[data-shipping-input-wrap]');
    var resultsEl = widget.querySelector('[data-shipping-results]');
    var errorEl = widget.querySelector('[data-shipping-error]');
    if (!countryWrap || !inputWrap || !resultsEl || !errorEl) return;

    var market = getMarket();
    var selectedCode = market.countryCode || 'IN';

    var labelEl = document.createElement('div');
    labelEl.className = 'shipping-estimate__country-label';
    labelEl.setAttribute('data-shipping-country', '');
    labelEl.setAttribute('aria-label', config.deliveryCountryLabel || 'Delivery country');
    labelEl.textContent = getCountryLabel(selectedCode, config);
    countryWrap.innerHTML = '';
    countryWrap.appendChild(labelEl);

    buildInputForCountry(selectedCode, config, widget);
  }

  function updateTimer(widget) {
    var timerEl = widget.querySelector('[data-shipping-timer]');
    if (!timerEl) return;
    var config = getConfig(widget);
    var orderWithinLabel = config.orderWithinLabel || 'Order within';
    var dispatchNextDayLabel = config.dispatchNextDayLabel || 'Orders placed now will dispatch next business day.';
    var hourSingular = config.hourSingular || 'hr';
    var hourPlural = config.hourPlural || 'hrs';
    var minuteSingular = config.minuteSingular || 'min';
    var minutePlural = config.minutePlural || 'mins';

    var next2pm = getNext2PMIST();
    var now = new Date();
    var ms = next2pm.getTime() - now.getTime();

    if (ms <= 0) {
      timerEl.innerHTML = '<span class="shipping-estimate__timer-message">' + dispatchNextDayLabel + '</span>';
      return;
    }

    var totalMins = Math.floor(ms / 60000);
    var hrs = Math.floor(totalMins / 60);
    var mins = totalMins % 60;
    var timeStr = hrs + ' ' + (hrs === 1 ? hourSingular : hourPlural) + ' ' + mins + ' ' + (mins === 1 ? minuteSingular : minutePlural);
    timerEl.innerHTML = '<span class="shipping-estimate__timer-label">' + orderWithinLabel + ' </span><strong class="shipping-estimate__timer-value">' + timeStr + '</strong>';
  }

  function startTimer(widget) {
    var timerEl = widget.querySelector('[data-shipping-timer]');
    if (timerEl) timerEl.style.display = 'none';
    setInterval(function() {
      var el = widget.querySelector('[data-shipping-timer]');
      if (el && el.style.display !== 'none') updateTimer(widget);
    }, 60000);
  }

  function initWidget(widget) {
    var config = getConfig(widget);
    var countryWrap = widget.querySelector('[data-shipping-country-wrap]');
    var inputWrap = widget.querySelector('[data-shipping-input-wrap]');
    var resultsEl = widget.querySelector('[data-shipping-results]');
    var errorEl = widget.querySelector('[data-shipping-error]');
    if (!inputWrap || !resultsEl || !errorEl) return;

    if (countryWrap) {
      buildCountryDropdown(config, widget);
    } else {
      var market = getMarket();
      if (market.key === 'default' || market.countryCode === 'IN') {
        buildInputIndia(config, widget);
      } else if (market.key === 'en-ae' || market.key === 'ar-ae' || market.countryCode === 'AE') {
        buildInputUAE(config, widget);
      } else if (['en-sa', 'ar-sa', 'en-gb', 'en-sg', 'en-us', 'en-ca', 'en-au'].indexOf(market.key) !== -1) {
        buildInputZip(market.countryCode, config, widget);
      } else {
        showHint(widget, config.regionFallbackMessage || 'Delivery estimates for your region: please contact us.');
        resultsEl.classList.remove('hidden');
      }
    }

    startTimer(widget);
  }

  function init() {
    var widgets = document.querySelectorAll('[data-shipping-estimate-widget]');
    for (var i = 0; i < widgets.length; i++) {
      initWidget(widgets[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
